import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { PdfExporterComponent } from './pdf-exporter.component';



@NgModule({
  declarations: [PdfExporterComponent],
  imports: [
    AppMaterialModule,
    CommonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [PdfExporterComponent]
})
export class PdfExporterModule { }
